import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

interface Section {
  title: string;
  description: string;
}

@Component({
    selector: 'app-digital-marketing',
    templateUrl: './digital-marketing.component.html',
    styleUrls: ['./digital-marketing.component.css'],
    standalone: false
})
export class DigitalMarketingComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Marketing Digital');
  }

  sections: Section[] = [
    {
      title: 'SEO Y CONTENIDOS DIGITALES',
      description: 'Estrategias de posicionamiento en buscadores, redes sociales y gestión de contenidos para mejorar la comercialización de tus productos o servicios en el entorno de la web 3.0.'
    },
    {
      title: 'INBOUND MARKETING',
      description: 'Asesoramiento en la captación de datos valiosos de marketing para su conversión en conocimiento útil y aportación de valor a toda la cadena de conversión del lead.'
    },
    {
      title: 'DIGITAL EXPERIENCE',
      description: 'Desarrollo de experiencias digitales basadas en las necesidades del cliente e integración de herramientas (CRM, CMS, ERP, Gestor de campañas) que impulsen la transformación digital de la empresa.'
    }
  ]

}
